import { useEffect, useRef, useState } from "react";
import { API } from "../lib/api";
import axios from "axios";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const initials = (n) => (n || "?").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

export default function NetworkMap() {
  const mapRef = useRef(null);
  const containerRef = useRef(null);
  const [count, setCount] = useState(null);

  useEffect(() => {
    document.title = "Carte du réseau STS — Sellerie Tout Simplement";
    if (mapRef.current || !containerRef.current) return;
    const map = L.map(containerRef.current, { scrollWheelZoom: true, attributionControl: true }).setView([46.6, 2.5], 5.4);
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19, attribution: "&copy; OpenStreetMap",
    }).addTo(map);

    axios.get(`${API}/public/network/members`).then((r) => {
      const members = r.data || [];
      setCount(members.length);
      const bounds = [];
      members.forEach((m) => {
        if (m.lat == null || m.lng == null) return;
        bounds.push([m.lat, m.lng]);
        const icon = L.divIcon({
          className: "",
          html: `<div style="position:relative;width:44px;height:44px">
            <div style="width:40px;height:40px;border-radius:50%;background:#0F172A;color:#7dd3fc;display:flex;align-items:center;justify-content:center;font-weight:700;font-family:sans-serif;border:2px solid #38BDF8;box-shadow:0 4px 10px rgba(0,0,0,.25)">${initials(m.name)}</div>
            <div style="position:absolute;top:-6px;right:-6px;background:#38BDF8;color:#0F172A;font-size:9px;font-weight:800;border-radius:999px;padding:1px 4px;border:1px solid #fff">STS</div>
          </div>`,
          iconSize: [44, 44], iconAnchor: [22, 44], popupAnchor: [0, -42],
        });
        const marker = L.marker([m.lat, m.lng], { icon }).addTo(map);
        const url = `${window.location.origin}/annuaire/${m.id}`;
        marker.bindPopup(
          `<div style="font-family:sans-serif;min-width:170px">
            <div style="font-weight:700;color:#0F172A;font-size:14px">${m.name}</div>
            <div style="color:#64748b;font-size:12px;margin-top:2px">${m.city || ""}</div>
            <div style="color:#f59e0b;font-size:12px;margin-top:4px">★ ${m.rating || "—"} <span style="color:#94a3b8">(${m.reviews_count} avis)</span></div>
            <a href="${url}" target="_blank" style="display:inline-block;margin-top:6px;color:#0284c7;font-size:12px;font-weight:600;text-decoration:none">Voir la fiche →</a>
          </div>`
        );
      });
      if (bounds.length > 0) map.fitBounds(bounds, { padding: [50, 50], maxZoom: 11 });
    }).catch(() => setCount(0));

    return () => { map.remove(); mapRef.current = null; };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="network-map-page">
      <header className="bg-navy text-white shrink-0">
        <div className="px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-sky-400 text-navy flex items-center justify-center font-display font-extrabold text-xs">STS</div>
            <div className="leading-tight">
              <div className="font-display font-bold text-sm">Réseau STS · Sellerie Tout Simplement</div>
              <div className="text-[11px] text-slate-300">{count == null ? "Chargement…" : `${count} atelier(s) membre(s)`}</div>
            </div>
          </div>
          <a href="/annuaire" className="text-sky-400 text-sm font-semibold hover:underline">Annuaire complet →</a>
        </div>
      </header>
      <div ref={containerRef} data-testid="leaflet-map" className="flex-1" style={{ minHeight: "70vh" }} />
    </div>
  );
}
